import {
  normalizeYuzuAssetUrls,
  resolveYuzuAssetUrl,
} from '~/utils/yuzuAssetUrls'

/** Holds host-provided display URLs separately from persisted builder state. */
export function useYuzuAssetUrls() {
  const assetUrls = useState<Record<string, string>>(
    'yuzu-builder:asset-urls',
    () => ({}),
  )

  function setAssetUrls(input: unknown) {
    assetUrls.value = normalizeYuzuAssetUrls(input)
  }

  function resolveAssetUrl(source: string) {
    return resolveYuzuAssetUrl(source, assetUrls.value)
  }

  return {
    assetUrls: readonly(assetUrls),
    setAssetUrls,
    resolveAssetUrl,
  }
}
